// extracted by mini-css-extract-plugin
module.exports = {"QuestionBlock":"FkBNb","QuestionBlock__active":"CV9Xu","QuestionBlock_Icon":"Yypx5","QuestionBlock_Title":"MTufV","QuestionBlock_ControlButton":"c53U4"};